export default __webpack_public_path__ + "locales/it/FillPDFDialog.json?hash=79b6bdc5ce9515f0efdb928d6486482a";